import react, { useState, useEffect, useRef } from "react";
import { db } from "./utils/firebase";
import { formatDate, formatTime, formatCurrency } from "./utils/format";
import { makeStyles } from "@material-ui/core/styles";
import Link from "../src/Link";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Game from "./Game";

const useStyles = makeStyles((theme) => ({
  games: {
    listStyle: "none",
    margin: 0,
    marginTop: 10,
    padding: 0,
    whiteSpace: "nowrap",
    overflowX: "scroll",
    "-ms-overflow-style": "none",
    "scrollbar-width": "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    // '&::-webkit-scrollbar-track': {
    //   background: 'rgba(26,42,54,.1)',
    //   borderRadius: 5,
    // },
    // '&::-webkit-scrollbar-thumb': {
    //   background: 'rgba(26,42,54,.15)',
    //   borderRadius: 5,
    // },
  },
  gamesWrapped: {
    listStyle: "none",
    margin: 0,
    marginTop: 10,
    padding: 0,
    [theme.breakpoints.down("sm")]: {
      whiteSpace: "nowrap",
      overflowX: "scroll",
      "&::-webkit-scrollbar": {
        height: 10,
      },
      "&::-webkit-scrollbar-track": {
        background: "rgba(26,42,54,.1)",
        borderRadius: 5,
      },
      "&::-webkit-scrollbar-thumb": {
        background: "rgba(26,42,54,.15)",
        borderRadius: 5,
      },
    },
  },
  gameWrapper: {
    display: "inline-block",
    marginRight: 20,
    marginBottom: 10,
  },
  game: {
    width: 320,
    padding: 10,
    display: "block",
    textDecoration: "none",
  },
  avatar: {
    width: 24,
    height: 24,
  },
  scrollContainer: {
    display: "flex",
    alignItems: 'center',
  },
  scrollButton: {
    [theme.breakpoints.down("sm")]: {
      display: 'none',
    }
  }
}));

const GameList = (props) => {
  const classes = useStyles();

  const { gameIds, tag, title, wrapped, ...other } = props;

  const [games, setGames] = useState([]);

  const listRef = useRef(null);

  useEffect(() => {
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    const statuses = [
      "scheduled",
      "inprogress",
      "flex-schedule", //FOOTBALL
      //"time-tbd", //FOOTBALL
      "created", //FOOTBALL
      "not_started", //SOCCER
      "initialized", //NASCAR
      "prerace", //NASCAR
      "practice", //NASCAR
      "qualifying", //NASCAR
      "if-necessary" //NHL
    ];

    let query;

    if (gameIds && gameIds.length > 0) {
      query = db.collectionGroup("games").where("apiKey", "in", gameIds);
    } else if (tag && tag.length > 0) {
      if (tag === "pga") {
        today = new Date();
        today.setUTCHours(0, 0, 0, 0);
        query = db
          .collectionGroup("games")
          .where("tags", "array-contains", db.collection("tags").doc(tag))
          .where("status", "in", statuses)
          .where("finished", ">=", today)
          .orderBy("finished")
          .limit(10);
      } else {
        query = db
          .collectionGroup("games")
          .where("tags", "array-contains", db.collection("tags").doc(tag === 'ncaab' ? 'ncaamb' : tag))
          .where("status", "in", statuses)
          .where("scheduled", ">=", today)
          .orderBy("scheduled")
          .limit(10);
      }
    } else {
      query = db
        .collectionGroup("games")
        .where("status", "in", statuses)
        .where("scheduled", ">=", today)
        .orderBy("scheduled")
        .limit(10);
    }

    query.get().then((results) => {
      setGames(
        results.docs.map((result) => {
          const scheduled = result.get("scheduled").toDate();
          const finished = result.get("finished");
          const utc = result.get("sport") === "Golf";

          return {
            apiKey: result.get("apiKey"),
            slug: result.get("slug"),
            startDate: formatDate(scheduled, utc),
            startTime: formatTime(scheduled, utc),
            endDate: finished ? formatDate(finished.toDate(), utc) : "",
            name: result.get("name"),
            away: result.get("awayName") || "",
            home: result.get("homeName") || "",
            sport: result.get("sport") || "",
            venue: result.get("venue") || "",
            network: result.get("network") || "",
            venueCity: result.get("venueCity") || "",
            venueState: result.get("venueState") || "",
            awayLine: result.get("awayCurrentLine") || "",
            homeLine: result.get("homeCurrentLine") || "",
            drawLine: result.get("drawCurrentLine") || "",
            total: result.get("totalCurrent") || "",
            spread: result.get("spreadCurrent") || "",
            spreadValue: Number(result.get('spreadCurrent') || "0"),
            outcomePlayer: result.get("outcomePlayer") || "",
            outcomeOdds: result.get("outcomeOdds") || "",
          };
        })
      );
    });
  }, [gameIds, tag]);

  return (
    <div {...other}>
      {title && title.length > 0 && (
        <Typography variant="h6">{title}</Typography>
      )}

      <div className={classes.scrollContainer}>
        {/* <button
          onClick={() => {
            listRef.current.scroll({
              left: listRef.current.scrollLeft - 1000,
              behavior: "smooth",
            });
          }}
        >
          Scroll List Left
        </button> */}


        {!wrapped && (
          <IconButton
            color="primary"
            aria-label="scroll left"
            component="span"
            onClick={() => {
              listRef.current.scroll({
                left: listRef.current.scrollLeft - 1000,
                behavior: "smooth",
              });
            }}
            className={classes.scrollButton}
          >
            <ArrowBackIcon />
          </IconButton>
        )}

        <Typography
          component="ul"
          className={wrapped ? classes.gamesWrapped : classes.games}
          ref={listRef}
        >
          {games.map((game, i) => {
            return (
              <li key={i} className={classes.gameWrapper}>
                <Paper
                  component="a"
                  href={`/games/${game.slug}/${game.apiKey}`}
                  className={classes.game}
                >
                  <Game game={game} />
                </Paper>
              </li>
            );
          })}
        </Typography>

        { !wrapped && (
          <IconButton
            color="primary"
            aria-label="scroll left"
            component="span"
            onClick={() => {
              listRef.current.scroll({
                left: listRef.current.scrollLeft + 1000,
                behavior: "smooth",
              });
            }}
            className={classes.scrollButton}
          >
            <ArrowForwardIcon />
          </IconButton>
        )}

        {/* <button
          onClick={() => {
            listRef.current.scroll({
              left: listRef.current.scrollLeft + 1000,
              behavior: "smooth",
            });
          }}
        >
          Scroll List Right
        </button> */}
      </div>

      {/* <button onClick={() => {
        console.log(listRef);
      }}>Log List Ref</button>

<button onClick={() => {
        listRef.current.draggable = true;
      }}>Log List Ref</button> */}
    </div>
  );
};

export default GameList;
